(() => {
  if (window.SpintzProductPolish) return;

  const countUnits = '(?:stk\\.?|stueck|stück(?:e)?|kapseln?|tabletten?|presslinge?|portionen?|beutel|dosen?|flaschen?|packs?|packungen?)';
  const unitPattern = new RegExp(
    `(\\d[\\d\\s.,']*)\\s*(µg|μg|mcg|mg|kg|g|ml|cl|dl|l|${countUnits})(?=\\s|$|[()\\[\\],;·/+-])`,
    'gi'
  );
  const numericOptionName = /(?:packungsgr(?:ö|oe)ße|gewicht|menge|anzahl|st(?:ü|ue)ck|kapsel|tablette|pressling|portion|quantity|count|size)/i;

  function parseNumber(raw) {
    let value = raw.replace(/[\s']/g, '');
    const comma = value.lastIndexOf(',');
    const dot = value.lastIndexOf('.');

    if (comma !== -1 && dot !== -1) {
      const decimalSeparator = comma > dot ? ',' : '.';
      const thousandsSeparator = decimalSeparator === ',' ? /\./g : /,/g;
      value = value.replace(thousandsSeparator, '').replace(decimalSeparator, '.');
    } else if (dot !== -1) {
      value = /^([1-9]\d{0,2})(?:\.\d{3})+$/.test(value) ? value.replace(/\./g, '') : value;
    } else if (comma !== -1) {
      value = /^([1-9]\d{0,2})(?:,\d{3})+$/.test(value) ? value.replace(/,/g, '') : value.replace(',', '.');
    }

    const number = Number.parseFloat(value);
    return Number.isFinite(number) ? number : null;
  }

  function comparableValue(text, optionName = '') {
    const normalized = String(text).trim().toLowerCase().replace(/\u00a0/g, ' ');
    const matches = Array.from(normalized.matchAll(unitPattern));

    if (matches.length) {
      const match = matches[0];
      const number = parseNumber(match[1]);
      if (number === null) return null;

      const unit = match[2].toLowerCase().replace('μ', 'µ').replace('.', '');
      const massFactors = { 'µg': 0.000001, mcg: 0.000001, mg: 0.001, g: 1, kg: 1000 };
      const volumeFactors = { ml: 1, cl: 10, dl: 100, l: 1000 };

      if (Object.prototype.hasOwnProperty.call(massFactors, unit)) {
        return { kind: 'mass', value: number * massFactors[unit] };
      }
      if (Object.prototype.hasOwnProperty.call(volumeFactors, unit)) {
        return { kind: 'volume', value: number * volumeFactors[unit] };
      }
      return { kind: 'count', value: number };
    }

    if (numericOptionName.test(optionName) && /^\s*\d[\d\s.,']*\s*$/.test(normalized)) {
      const number = parseNumber(normalized);
      return number === null ? null : { kind: 'count', value: number };
    }

    return null;
  }

  function sortableEntries(entries, optionName) {
    const parsed = entries.map((entry, index) => ({
      ...entry,
      index,
      comparable: comparableValue(entry.value, optionName)
    }));
    if (parsed.length < 2 || parsed.some(entry => !entry.comparable)) return null;
    const kind = parsed[0].comparable.kind;
    if (parsed.some(entry => entry.comparable.kind !== kind)) return null;
    return parsed.sort((a, b) => a.comparable.value - b.comparable.value || a.index - b.index);
  }

  function sortFieldset(fieldset) {
    if (fieldset.dataset.spintzNumericSorted === 'true') return;
    const inputs = Array.from(fieldset.children).filter(node => node.matches?.('input[type="radio"]'));
    const optionName = fieldset.dataset.optionName || fieldset.querySelector('legend')?.textContent || '';
    const entries = inputs.map(input => ({
      input,
      label: Array.from(fieldset.children).find(node => node.tagName === 'LABEL' && node.htmlFor === input.id),
      value: input.value
    })).filter(entry => entry.label);
    const sorted = sortableEntries(entries, optionName);

    if (sorted) {
      const fragment = document.createDocumentFragment();
      sorted.forEach(entry => {
        fragment.append(entry.input, entry.label);
      });
      fieldset.append(fragment);
    }
    fieldset.dataset.spintzNumericSorted = 'true';
  }

  function sortSelect(select) {
    if (select.dataset.spintzNumericSorted === 'true') return;
    const options = Array.from(select.options).filter(option => option.value !== '');
    const optionName = select.name || select.closest('[data-option-name]')?.dataset.optionName || '';
    const sorted = sortableEntries(options.map(option => ({ option, value: option.value })), optionName);

    if (sorted) {
      const fragment = document.createDocumentFragment();
      sorted.forEach(entry => fragment.append(entry.option));
      select.append(fragment);
    }
    select.dataset.spintzNumericSorted = 'true';
  }

  function sort(root = document) {
    root.querySelectorAll?.('fieldset.product-form__input').forEach(sortFieldset);
    root.querySelectorAll?.('select[id^="Option-"]').forEach(sortSelect);
  }

  let sortQueued = false;
  function queueSort() {
    if (sortQueued) return;
    sortQueued = true;
    requestAnimationFrame(() => {
      sortQueued = false;
      sort(document);
    });
  }

  window.SpintzProductPolish = { sort };
  sort(document);

  const observer = new MutationObserver(queueSort);
  observer.observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', queueSort);
})();
